<app-pdftron
	[url]="data.downloadUrl"
	class="min-h-[calc(100vh-300px)] flex flex-1 w-full [&>div]:w-full [&>div]:!h-auto"
	[setFitMode]="'FitWidth'"
></app-pdftron>
